import { React, useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { getEssentialProducts } from "../../constants/essential_products";
import { main_paige_title } from "../../constants/constants";

const About = () => {
    const targetRef = useRef();
    const [essentialProducts, setEssentialProducts] = useState([]);

    useEffect(() => {
        setEssentialProducts(getEssentialProducts());
    }, []);

    return (
        <div>
            <Helmet>
                <title property="title">{main_paige_title} - Über uns</title>
            </Helmet>
            <Header />
            <main id="content">
                {/* HERO SECTION */}
                <section
                    className="d-flex flex-column bg-img-cover-center vh-100 pt-xxl-13 custom-height-sm"
                    style={{ backgroundImage: "url('images/bg-about-us-02.jpg')" }}
                >
                    <div className="d-flex flex-column h-100 justify-content-center">
                        <div className="container container-xxl">
                            <h1 className="fs-60 mb-4">Über uns</h1>
                            <p className="mb-0 mxw-435px">
                                Wir verbinden modernes Regalsystem-Design mit hochwertigen
                                Acrylglaslösungen, um Funktionalität und Stil in jedem Raum
                                perfekt zu vereinen.
                            </p>
                        </div>
                    </div>
                </section>

                {/* INTRO SECTION */}
                <section className="pt-11 pt-lg-15">
                    <div className="container">
                        <div className="mxw-924 mx-auto mb-7">
                            <h2 className="fs-30 fs-md-40 lh-15 text-center mb-0">
                                Ein Ort für alles – weil klare Ordnung und ansprechendes Design
                                das Leben bereichern.
                            </h2>
                        </div>
                        <div className="mxw-830 mx-auto mb-8">
                            <p className="fs-20 text-primary font-weight-500 mb-5">
                                Wir bei <strong>Luminit</strong> glauben, dass gut strukturierte
                                Räume mehr Gelassenheit schaffen. Unsere Regalsysteme aus
                                nachhaltigen Materialien und unsere edlen Acrylglasprodukte
                                setzen dabei stilvolle Akzente.
                            </p>
                            <p className="mb-1">
                                Unser Anspruch ist es, formschöne Designs zu entwickeln, die
                                sowohl praktisch als auch ästhetisch sind. Dabei legen wir Wert
                                auf verantwortungsvolle Herstellung, langlebige Qualität und
                                zeitloses Aussehen. Unsere Kunden sollen sich nicht nur
                                organisieren können, sondern dabei auch Freude an unseren
                                Produkten haben.
                            </p>
                        </div>
                        <img
                            src="images/b-17.jpg"
                            alt="Image"
                            className="mb-10"
                        />
                        <div className="mxw-830 mx-auto">
                            <h2 className="fs-30 fs-md-40 lh-15 text-center mb-4">
                                Gemeinsam schaffen wir Räume, in denen Design und Funktion
                                verschmelzen
                            </h2>
                            <p className="mb-0">
                                Ob dezente Acrylglas-Ablagen oder auffällige Regalsysteme – bei
                                uns finden Sie Produkte, die sich nahtlos in Ihre Umgebung
                                einfügen und gleichzeitig für das gewisse Etwas sorgen.
                                Nachhaltigkeit und Qualität sind dabei unsere Leitlinien, um
                                Ihnen Möbel und Accessoires zu bieten, an denen Sie lange
                                Freude haben. Erleben Sie mit <strong>Luminit</strong> ein
                                Wohnerlebnis, das modern, elegant und dennoch angenehm
                                unkompliziert ist.
                            </p>
                        </div>
                    </div>
                </section>

                {/* THREE-COLUMN SECTION */}
                <section className="pt-11 pt-lg-15">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 mb-6 mb-md-0">
                                <div className="card border-0">
                                    <img
                                        src="images/image-box-01.jpg"
                                        alt="Regalsysteme"
                                    />
                                    <div className="card-body px-0 pt-6 pb-0">
                                        <h3 className="fs-20 mb-3">Regalsysteme</h3>
                                        <p className="mb-0">
                                            Durchdachte Konstruktionen, die Ihnen helfen, Platz optimal
                                            zu nutzen und gleichzeitig einen modernen Look zu
                                            schaffen.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 mb-6 mb-md-0">
                                <div className="card border-0">
                                    <img
                                        src="images/image-box-02.jpg"
                                        alt="Acrylglas-Kollektion"
                                    />
                                    <div className="card-body px-0 pt-6 pb-0">
                                        <h3 className="fs-20 mb-3">Acrylglas-Kollektion</h3>
                                        <p className="mb-0">
                                            Hochwertige und transparente Designs, perfekt für
                                            Präsentation und Aufbewahrung. Bringen Sie Leichtigkeit in
                                            jeden Raum.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 mb-6 mb-md-0">
                                <div className="card border-0">
                                    <img
                                        src="images/image-box-03.jpg"
                                        alt="Zubehör & Mehr"
                                    />
                                    <div className="card-body px-0 pt-6 pb-0">
                                        <h3 className="fs-20 mb-3">Zubehör & Mehr</h3>
                                        <p className="mb-0">
                                            Ergänzen Sie Ihre Einrichtung mit praktischen und
                                            stilvollen Extras – von dekorativen Accessoires bis hin zu
                                            funktionalen Ordnungssystemen.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* INFO SECTION */}
                <section className="py-11 py-lg-15">
                    <div className="container">
                        <div className="row no-gutters">
                            <div className="col-lg-3 mb-8 mb-lg-0">
                                <h2 className="fs-30 fs-md-40 lh-15 mb-6 pt-lg-5">
                                    Informationen
                                </h2>
                                <p className="font-weight-bold text-primary mb-4">Adresse</p>
                                <address className="mb-6">
                                    Denhardstraße. 24
                                    41189 Mönchengladbach
                                    <br />
                                    Deutschland
                                </address>
                                <p className="font-weight-bold text-primary mb-3">
                                    Kontakt
                                </p>
                                <p className="mb-0">+49 171 6181197</p>
                                <p className="mb-7">info@luminit.de</p>
                                <a href="/contact" className="btn btn-primary">
                                    Kontakt aufnehmen
                                </a>
                            </div>
                            <div className="col-lg-9">
                                <div className="pl-lg-10">
                                    <img
                                        src="images/b-21.jpg"
                                        alt="Image"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default About;